import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { store } from "../../store/store";

const baseUrl = process.env.REACT_APP_base_URL;

const InviteSolutionProvider = createApi({
    reducerPath: 'InviteSolutionProvider',
    baseQuery: fetchBaseQuery({
        baseUrl: baseUrl,
        prepareHeaders: (headers) => {
            // const token = useSelector((state)=> state.user.token)
            const token = store.getState().user.token;
            if (token) {
              headers.set('Authorization', `Bearer ${token}`);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        inviteSolutionProvider: builder.mutation({
            query: ({boardId , userId , solutionId , solutionName , solutionProviderId}) => ({
                url: `requirement_boards/invite-solution`, // Replace with your API endpoint URL
                method: 'POST',
                body: { 
                    userId: userId,
                    boardId: boardId,
                    solutionId: solutionId,
                    solutionName: solutionName,
                    solutionProviderId: solutionProviderId,
            },
            }),
            transformResponse: (response) => {
                if(response.status != false){
                return response;
              }else{
                return  response = [];
               }
            },
        }),
    }),
});

export const { useInviteSolutionProviderMutation } = InviteSolutionProvider;
export default InviteSolutionProvider
